<div class="row" *ngIf="showDashboard">
    <div class="col">

        <div class="h-100">
            <div class="row mb-3 pb-1">
                <div class="col-12">
                    <div class="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div class="flex-grow-1">
                            <h4 class="fs-16 mb-1">Hey There!</h4>
                            <p class="text-muted mb-0">Here's what's happening with your store today.</p>
                        </div>
                    </div><!-- end card header -->
                </div>
                <!--end col-->
            </div>
            <!--end row-->
            <div class="row mt-3">
                <div class="col-12">
                    <div class="d-flex align-items-lg-center flex-lg-row flex-column">
                        <div class="flex-grow-1">
                            <div class="row d-flex align-items-center justify-content-between">
                                <div class="col-md-6">
                                    <div class="card" style="border-radius: 10px;">
                                        <div class="mt-1 mb-1">
                                            <div class="d-flex justify-content-between">
                                                <div class="card-body col-md-3 cursor-pointer hover-css"
                                                    (click)="dateFilter('yearly')"
                                                    [ngClass]="{'activeFilter': filter === 'yearly'}">
                                                    <div class="d-flex justify-content-center">
                                                        <h6 class="m-0" style="font-weight: 600;">Yearly</h6>
                                                    </div>
                                                </div>
                                                <div class="card-body col-md-3 cursor-pointer hover-css"
                                                    (click)="dateFilter('monthly')"
                                                    [ngClass]="{'activeFilter': filter === 'monthly'}">
                                                    <div class="d-flex justify-content-center">
                                                        <h6 class="m-0" style="font-weight: 600;">Monthly</h6>
                                                    </div>
                                                </div>
                                                <div class="card-body col-md-3 cursor-pointer hover-css"
                                                    (click)="dateFilter('weakly')"
                                                    [ngClass]="{'activeFilter': filter === 'weakly'}">
                                                    <div class="d-flex justify-content-center">
                                                        <h6 class="m-0" style="font-weight: 600;">Weekly</h6>
                                                    </div>
                                                </div>
                                                <div class="card-body col-md-3 cursor-pointer hover-css"
                                                    (click)="dateFilter('daily')"
                                                    [ngClass]="{'activeFilter': filter === 'daily'}">
                                                    <div class="d-flex justify-content-center">
                                                        <h6 class="m-0" style="font-weight: 600;">Daily</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- </div>   -->
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mt-0 mt-lg-0">
                            <div class="row g-3 mb-0 align-items-center">
                                <div class="col-sm-auto">
                                    <div class="d-flex gap-2">
                                        <div class="input-group">
                                            <div class="input-group-text bg-primary border-primary text-white"><i
                                                    class="ri-calendar-2-line"></i></div>
                                            <input class="form-control flatpickr-input" [(ngModel)]="dateRange"
                                                type="text" mwlFlatpickr [altInput]="true" [convertModelValue]="true"
                                                mode="range">

                                        </div>
                                        <button class="btn btn-primary" (click)="onFilter()">Filter</button>
                                        <button *ngIf="showClearFilterBtn" class="btn btn-danger"
                                            (click)="onClearFilter()">Clear</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div *ngFor="let stat of statData" class="col-xl-4 col-md-6">
                    <div class="card p-0" style="border-radius: 10px;">
                        <div class="card-body">
                            <div class="d-flex gap-2">
                                <div class="avatar-sm flex-shrink-0">
                                    <span class="avatar-title rounded fs-3 bg-soft-success">
                                        <i class="bx {{stat.icon}} text-primary"></i>
                                    </span>
                                </div>
                                <div>
                                    <h4 class="fs-22 fw-semibold ff-secondary mb-1">
                                        <!-- <span *ngIf="stat.title == 'TOTAL EARNINGS' || stat/title == 'MY BALANCE' || stat.title == 'AVERAGE ORDER VALUE'">₹</span> -->
                                        <span [CountTo]="stat.value" class="counter-value" [from]="0"
                                            [duration]="1">0</span>
                                        <!-- <span *ngIf="stat.title == 'TOTAL EARNINGS' || stat.title == 'MY BALANCE'">K</span>
                                        <span *ngIf="stat.title == 'CUSTOMERS'">M</span> -->
                                    </h4>
                                    <div class="flex-grow-1 overflow-hidden">
                                        <span
                                            class="text-uppercase fw-medium text-muted text-truncate mb-0 title-font">{{stat.title}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <app-stat [title]="stat.title" [value]="stat.value" [icon]="stat.icon"
                        [persantage]="stat.persantage" [profit]="stat.profit"></app-stat> -->
                </div>
            </div> <!-- end row-->

            <div class="row">
                <div class="col-xl-6">
                    <div class="card" style="border-radius: 10px;">
                        <div class="card-header border-0 align-items-center d-flex"
                            style="border-radius: 10px 10px 0 0;">
                            <h4 class="card-title mb-0 flex-grow-1">Gross Sale</h4>
                            <!-- <div class="d-flex gap-1">
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    ALL
                                </button>
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    1M
                                </button>
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    6M
                                </button>
                                <button type="button" class="btn btn-soft-primary btn-sm">
                                    1Y
                                </button>
                            </div> -->
                        </div><!-- end card header -->
                        <!-- <div class="card-header p-0 border-0 bg-soft-light">
                            <div class="row g-0 text-center">
                                <div class="col-6 col-sm-4">
                                    <div class="p-3 border border-dashed border-start-0">
                                        <h5 class="mb-1">
                                            <span [CountTo]="854" class="counter-value" [from]="0" [duration]="1"></span>
                                            <span class="text-success ms-1 fs-12">49%<i class="ri-arrow-right-up-line ms-1 align-middle"></i></span>
                                        </h5>
                                        <p class="text-muted mb-0">Avg. Sale</p>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4">
                                    <div class="p-3 border border-dashed border-start-0">
                                        <h5 class="mb-1"><span [CountTo]="1278" class="counter-value" [from]="0" [duration]="1"></span>
                                            <span class="text-success ms-1 fs-12">60%<i class="ri-arrow-right-up-line ms-1 align-middle"></i></span>
                                        </h5>
                                        <p class="text-muted mb-0">Conversion Rate</p>
                                    </div>
                                </div>
                                <div class="col-6 col-sm-4">
                                    <div class="p-3 border border-dashed border-start-0 border-end-0">
                                        <h5 class="mb-1"><span [CountTo]="3" class="counter-value" [from]="0" [duration]="1"></span>m <span [CountTo]="40" class="counter-value" [from]="0" [duration]="1"></span>sec
                                            <span class="text-success ms-1 fs-12">37%<i class="ri-arrow-right-up-line ms-1 align-middle"></i></span>
                                        </h5>
                                        <p class="text-muted mb-0">Avg. Sale Duration</p>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="card-body p-0 pb-2">
                            <div class="mb-n2">
                                <apx-chart [series]="grossSellChart?.series" [chart]="grossSellChart?.chart"
                                    [colors]="grossSellChart?.colors" [dataLabels]="grossSellChart?.dataLabels"
                                    [plotOptions]="grossSellChart?.plotOptions" [yaxis]="grossSellChart?.yaxis"
                                    [legend]="grossSellChart?.legend" [fill]="grossSellChart?.fill"
                                    [stroke]="grossSellChart?.stroke" [tooltip]="grossSellChart?.tooltip"
                                    [xaxis]="grossSellChart?.xaxis"></apx-chart>
                            </div>
                        </div><!-- end card body -->
                    </div><!-- end card -->
                </div><!-- end col -->
                <div class="col-xl-6">
                    <div class="card" style="border-radius: 10px;">
                        <div class="card-header border-0 align-items-center d-flex"
                            style="border-radius: 10px 10px 0 0;">
                            <h4 class="card-title mb-0 flex-grow-1">Total Orders</h4>
                            <!-- <div class="d-flex gap-1">
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    ALL
                                </button>
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    1M
                                </button>
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    6M
                                </button>
                                <button type="button" class="btn btn-soft-primary btn-sm">
                                    1Y
                                </button>
                            </div> -->
                        </div><!-- end card header -->
                        <div class="card-body p-0 pb-2">
                            <div class="mb-n2">
                                <apx-chart [series]="totalOrderChart?.series" [chart]="totalOrderChart?.chart"
                                    [colors]="totalOrderChart?.colors" [dataLabels]="totalOrderChart?.dataLabels"
                                    [plotOptions]="totalOrderChart?.plotOptions" [yaxis]="totalOrderChart?.yaxis"
                                    [legend]="totalOrderChart?.legend" [fill]="totalOrderChart?.fill"
                                    [stroke]="totalOrderChart?.stroke" [tooltip]="totalOrderChart?.tooltip"
                                    [xaxis]="totalOrderChart?.xaxis"></apx-chart>
                            </div>
                        </div><!-- end card body -->
                    </div><!-- end card -->
                </div><!-- end col -->

                <div class="col-xl-6">
                    <div class="card" style="border-radius: 10px;">
                        <div class="card-header border-0 align-items-center d-flex"
                            style="border-radius: 10px 10px 0 0;">
                            <h4 class="card-title mb-0 flex-grow-1">Total Transactions</h4>
                            <!-- <div class="d-flex gap-1">
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    ALL
                                </button>
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    1M
                                </button>
                                <button type="button" class="btn btn-soft-secondary btn-sm">
                                    6M
                                </button>
                                <button type="button" class="btn btn-soft-primary btn-sm">
                                    1Y
                                </button>
                            </div> -->
                        </div><!-- end card header -->
                        <div class="card-body p-0 pb-2">
                            <div class="mb-n2">
                                <apx-chart [series]="totalTransactionChart?.series"
                                    [labels]="totalTransactionChart?.labels" [chart]="totalTransactionChart?.chart"
                                    [plotOptions]="totalTransactionChart?.plotOptions"
                                    [dataLabels]="totalTransactionChart?.dataLabels"
                                    [legend]="totalTransactionChart?.legend" [stroke]="totalTransactionChart?.stroke"
                                    [yaxis]="totalTransactionChart?.yaxis"
                                    [colors]="totalTransactionChart?.colors"></apx-chart>
                            </div>
                        </div><!-- end card body -->
                    </div><!-- end card -->
                </div><!-- end col -->

            </div>
        </div>
    </div>
</div>
<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>